(() => {
  if (customElements.get('petsroute-countdown')) return;
  const dateFormat = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit'
  });
  // Find the next Madrid date boundary, including 23/25-hour DST days.
  function nextMidnight(now) {
    const today = dateFormat.format(new Date(now));
    let low = Math.floor(now / 1000), high = low + 27 * 3600;
    while (high - low > 1) {
      const middle = Math.floor((low + high) / 2);
      if (dateFormat.format(new Date(middle * 1000)) === today) low = middle;
      else high = middle;
    }
    return high * 1000;
  }
  class PetsRouteCountdown extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.target = 0;
      this.fields = {};
      this.querySelectorAll('[data-pr-unit]').forEach(el => this.fields[el.dataset.prUnit] = el);
      this.update = () => {
        const now = Date.now();
        if (!this.target || now >= this.target || this.target - now > 27 * 3600000) this.target = nextMidnight(now);
        let remaining = Math.max(0, Math.ceil((this.target - now) / 1000));
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        Object.entries(values).forEach(([key, value]) => { if (this.fields[key]) this.fields[key].textContent = String(value).padStart(2, '0'); });
        const clock = this.querySelector('.pr-countdown__clock');
        if (clock) clock.hidden = false;
      };
      this.update();
      this.section = this.closest('.shopify-section');
      this.measure = () => {
        if (this.section) document.documentElement.style.setProperty(
          '--pr-announcement-height', `${this.section.getBoundingClientRect().height}px`
        );
      };
      this.measure();
      if (window.ResizeObserver && this.section) {
        this.resizeObserver = new ResizeObserver(this.measure);
        this.resizeObserver.observe(this.section);
      }
      window.addEventListener('resize', this.measure);
      this.interval = setInterval(this.update, 1000);
      document.addEventListener('visibilitychange', this.update);
    }
    stop() {
      clearInterval(this.interval);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.measure) window.removeEventListener('resize', this.measure);
      if (this.section) document.documentElement.style.removeProperty('--pr-announcement-height');
      if (this.update) document.removeEventListener('visibilitychange', this.update);
    }
    disconnectedCallback() { this.stop(); }
  }
  customElements.define('petsroute-countdown', PetsRouteCountdown);
})();
